import type { RegulatoryClassificationData } from "./regulatoryClassification.interface";

const isRegulatoryClassificationMap = (
  value: unknown,
): value is RegulatoryClassificationData => {
  if (!value || typeof value !== "object") return false;

  const firstEntry = Object.entries(value)[0];
  if (!firstEntry) return true;

  const [, item] = firstEntry;
  return (
    typeof item === "object" &&
    item !== null &&
    "displayValue" in item &&
    "viewOrder" in item
  );
};

const getRegulatoryClassificationMap = (
  response: unknown,
): RegulatoryClassificationData => {
  if (!isRegulatoryClassificationMap(response)) return {};

  return response;
};

const toFilterList = (map: RegulatoryClassificationData) =>
  Object.entries(map)
    .sort(([, a], [, b]) => a.viewOrder - b.viewOrder)
    .map(([code, value]) => ({
      code,
      name: value.displayValue,
      isCheck: false,
    }));

export const adaptRegulatoryClassification = (response: unknown) => {
  const map = getRegulatoryClassificationMap(response);

  return Object.entries(map)
    .sort(([, a], [, b]) => a.viewOrder - b.viewOrder)
    .reduce((acc, [code, value]) => {
      acc[code] = value.displayValue;
      return acc;
    }, {} as Record<string, string>);
};

export const adaptRegulatoryClassificationFilter = (response: unknown) => {
  const list = toFilterList(getRegulatoryClassificationMap(response));

  return {
    ai: list,
    manual: [
      ...list,
      {
        code: "",
        name: "None",
        isCheck: false,
      },
    ],
  };
};
